'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'ritetag';
var iconName = 'ritetagHashtagSuggestion';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f26e';
var svgPathData = 'M502.62,94.23C515.12,106.721 515.12,126.99 502.62,139.47L139.48,502.62C133.23,508.87 125.04,511.99 116.85,511.99C108.67,511.99 100.48,508.87 94.23,502.62L9.38,417.77C-3.12,405.28 -3.12,385.02 9.38,372.52L372.52,9.38C378.77,3.12 386.96,0 395.15,0C403.34,0 411.53,3.12 417.77,9.38L502.62,94.23ZM432,288L405.34,341.33L352,368L405.34,394.67L432,448L458.66,394.67L512,368L458.66,341.33L432,288ZM272,191.737L65.28,396.163L116.542,448L323.262,243.574L272,191.737ZM359.45,203.46L446.05,116.86L395.14,65.95L308.54,152.55L359.45,203.46ZM80,160L106.66,106.67L160,80L106.66,53.33L80,0L53.34,53.33L0,80L53.34,106.67L80,160ZM224,96L240,64L272,48L240,32L224,0L208,32L176,48L208,64L224,96Z';

exports.definition = {
    prefix: prefix,
    iconName: iconName,
    icon: [
        width,
        height,
        ligatures,
        unicode,
        svgPathData
    ]};

exports.ritetagHashtagSuggestion = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
